<template>
    <div>
        <app-section-loader :status="form_loader"></app-section-loader>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-refresh
                                @invoke-method="getPending(repack.is_nonconformance == '0' ? 'batches' : 'nonconformances')"
                                permanent
                            ></bc-btn-refresh>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-form ref="create_package">
                    <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                        <v-layout row wrap :class="$bp.smallScreen ? 'pa-2' : 'pa-0'">
                            <v-flex xs4 md3 pb-2 align-self-start>
                                <span class="font-md">{{ $t('lang.part_name') }}</span>
                                <h2>{{ currObjField('name') ? currObjField('name') : '---' }}</h2>
                            </v-flex>
                            <v-flex xs4 md2 pb-2 align-self-start>
                                <span class="font-md">{{ $t('lang.dta_part_code') }}</span>
                                <h2>{{ currObjField('dta_part_code') ? currObjField('dta_part_code') : '---' }}</h2>
                            </v-flex>
                            <v-flex xs4 md3 pb-2 align-self-start>
                                <span class="font-md">{{ $t('lang.company') }}</span>
                                <h2>{{ currObjField('company') ? currObjField('company') : '---' }}</h2>
                            </v-flex>
                            <v-flex xs6 md2 pb-2 align-self-start>
                                <v-switch
                                    v-model="repack.is_nonconformance"
                                    :label="repack.is_nonconformance == '0' ? $t('lang.batches') : $t('lang.nonconformances')"
                                    :readonly="table_loader"
                                    true-value="1"
                                    false-value="0"
                                ></v-switch>
                            </v-flex>
                            <v-flex xs6 md2 pb-2 align-self-start>
                                <v-switch
                                    v-model="repack.multi_repack"
                                    :label="repack.multi_repack == '1' ? $t('lang.multiple') : $t('lang.single')"
                                    true-value="1"
                                    false-value="0"
                                ></v-switch>
                            </v-flex>
                            <v-flex xs12 pa-0 mt-3>
                                <bc-autocomplete
                                    v-model="repack.shipping_unit_id"
                                    :label="`${$t('lang.shipping_unit')} *`"
                                    :items="shipping_unit_options"
                                    item-value="shipping_unit_id"
                                    item-text="shipping_unit"
                                    :rules="ifValid('repack.shipping_unit_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12 pa-0>
                                <v-textarea
                                    v-model="repack.notes"
                                    :label="$t('lang.notes')"
                                    auto-grow
                                    rows="1"
                                ></v-textarea>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="goBack()">{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyRepack('post')" :disabled="selected_batches.length == 0">{{ $t('lang.create') }}</v-btn>
                    </v-card-actions>
                    <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                        <v-layout row wrap pa-0>
                            <v-flex xs12>
                                <!-- <app-section-loader :status="table_loader"></app-section-loader> -->
                                <v-data-table
                                    v-if="repack.is_nonconformance == '0'"
                                    v-model="selected_batches"
                                    :headers="batches_headers"
                                    :items="pending_batches"
                                    item-key="batch_id"
                                    :no-data-text="$t('lang.no_results_matching')"
                                    hide-actions
                                    select-all
                                >
                                    <template slot="items" slot-scope="props">
                                        <tr v-if="props && props.item">
                                            <td>
                                                <v-checkbox
                                                    @click.stop="props.selected = !props.selected"
                                                    :input-value="props.selected"
                                                    primary
                                                    hide-details
                                                    tabindex="-1"
                                                ></v-checkbox>
                                            </td>
                                            <td class="clickable" @click.stop="props.selected = !props.selected">{{ props.item.batch_control_id }}</td>
                                            <td :class="{ 'clickable' : !props.selected }" @click="!props.selected ? props.selected = !props.selected : ''">
                                                <v-text-field
                                                    v-focus="props.index == 0 ? repack_dialog : false"
                                                    v-model="repack_qty[props.index]"
                                                    :label="`${$t('lang.qty')} *`"
                                                    single-line
                                                    hide-details
                                                    :disabled="!props.selected"
                                                    :counter="showCounter(repack.repack_qty, 'repack.repack_qty')"
                                                    :rules="props.selected ? ifValid([...evalRules(rules_repack.repack_qty.rules), ...$r.max_value(props.item.remaining_repack)]) : []"
                                                    type="number"
                                                ></v-text-field>
                                            </td>
                                            <td class="text-center clickable" @click.stop="props.selected = !props.selected">{{ props.item.remaining_repack }}</td>
                                            <td class="text-center clickable" @click.stop="props.selected = !props.selected">{{ props.item.total_removed }}</td>
                                            <td class="text-center clickable" @click.stop="props.selected = !props.selected">{{ props.item.total_processed }}</td>
                                            <td class="text-center">
                                                <bc-btn-nonconformance
                                                    entity_object="work_orders_batch"
                                                    :entity_id="props.item.batch_id"
                                                    permanent
                                                ></bc-btn-nonconformance>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                                <v-data-table
                                    v-else
                                    v-model="selected_batches"
                                    :headers="nonconformances_headers"
                                    :items="nonconformances || []"
                                    item-key="nonconformance_id"
                                    :no-data-text="$t('lang.no_results_matching')"
                                    hide-actions
                                    select-all
                                >
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td>
                                                <v-checkbox
                                                    @click.stop="props.selected = !props.selected"
                                                    :input-value="props.selected"
                                                    primary
                                                    hide-details
                                                ></v-checkbox>
                                            </td>
                                            <td>{{ props.item.description }}</td>
                                            <td>
                                                <v-text-field
                                                    v-focus="props.index == 0 ? repack_dialog : false"
                                                    v-model="repack_qty[props.index]"
                                                    :label="`${$t('lang.qty')} *`"
                                                    single-line
                                                    hide-details
                                                    :disabled="!props.selected"
                                                    :counter="showCounter(repack.repack_qty, 'repack.repack_qty')"
                                                    :rules="props.selected ? ifValid([...evalRules(rules_repack.repack_qty.rules), ...$r.max_value(props.item.nonconformance_qty)]) : []"
                                                    type="number"
                                                ></v-text-field>
                                            </td>
                                            <td class="text-center">{{ props.item.nonconformance_qty }}</td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-form>
            </v-card>
        </v-container>
        <delete-confirmation-dialog
            ref="repackConfirmDialog"
            :headline="$t('lang.confirm_partial_batch')"
            message="The repack quanity is less than the available repack quantity and there is still room in the container, are you sure you want to continue?"
            @onConfirm="confirmCreate()"
        ></delete-confirmation-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            batches_headers: [
                { text: this.$t("lang.dta_control"), sortable: false, width: "20%" },
                { text: this.$t("lang.repack_qty"), sortable: false, width: "20%" },
                { text: this.$t("lang.available_qty"), sortable: false, width: "20%", align: "center" },
                { text: this.$t("lang.removed_qty"), sortable: false, width: "15%", align: "center" },
                { text: this.$t("lang.processed_qty"), sortable: false, width: "15%", align: "center" },
                { text: "", sortable: false, width: "10%", align: "center" },
            ],
            nonconformances_headers: [
                { text: this.$t("lang.description"), sortable: false, width: "50%" },
                { text: this.$t("lang.repack_qty"), sortable: false },
                { text: this.$t("lang.removed_qty"), sortable: false, align: "center" },
            ],
            repack: {
                is_nonconformance: "0",
                shipping_unit_id: "",
                notes: "",
            },
            repack_qty: [],
            current_obj: null,
            selected_batches: [],
            filter: {
                search: "",
                company_id: "",
                page_size: 0,
                page_num: 0,
            },
            table_loader: false,
            form_loader: false,
            repack_dialog: false,
            part_dialog: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        // let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store.dispatch("fetchSetting", {
            url: "shipping_unit_options",
            method: "get",
            stateProperty: "shipping_unit_options",
            commit: true,
        });

        store
            .dispatch("fetchRepack", {
                url: "repack/pending_batches",
                method: "get",
                stateProperty: "pending_batches",
                commit: true,
                body: {
                    part_id: to.params.id,
                },
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.pending_batches) {
                    next((vm) => {
                        vm.repack_qty = Array((data.pending_batches || []).length).fill("");
                        // vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.getPartInfo(to.params.id);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        // let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.getPartInfo(to.params.id);

        this.$store.dispatch("fetchSetting", {
            url: "shipping_unit_options",
            method: "get",
            stateProperty: "shipping_unit_options",
            commit: true,
        });

        this.$store
            .dispatch("fetchRepack", {
                url: "repack/pending_batches",
                method: "get",
                stateProperty: "pending_batches",
                commit: true,
                body: {
                    part_id: to.params.id,
                },
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.pending_batches) {
                    // this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.repack_qty = Array((data.pending_batches || []).length).fill("");
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_repack: (state) => state.validation.rules_repack,
            page: (state) => state.parts.page,
            pending_batches: (state) => state.repack.pending_batches,
            shipping_unit_options: (state) => state.settings.shipping_unit_options,
            nonconformances: (state) => state.nonconformance.nonconformances,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.pending_batches && this.pending_batches.length > 0 && field && this.pending_batches[0][field] ? this.pending_batches[0][field] : "";
            };
        },
    },
    watch: {
        "repack.is_nonconformance": function(newVal, oldVal) {
            this.getPending(newVal ? "batches" : "nonconformances");
        },
    },
    methods: {
        openPartDialog() {
            this.part_dialog = true;
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchRepack", {
                    url: `repack/pending_parts_summary`,
                    method: "get",
                    stateProperty: "pending_parts_summary",
                    commit: true,
                })
                .then((data) => {
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        confirmCreate() {
            this.$refs.repackConfirmDialog.close();
            this.modifyRepack("post", true);
        },
        modifyRepack(method = null, confirm = false) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (this.validateForm("create_package")) {
                        if (this.selected_batches && (this.selected_batches || []).length > 0) {
                            // check if any quanity is partially filled and open confirm if true
                            let notFullBatches = [];
                            notFullBatches = this.selected_batches.filter(
                                (b) => +this.repack_qty[this.pending_batches.map((p) => p.batch_id).indexOf(b.batch_id)] < +b.remaining_repack
                            );
                            if (notFullBatches.length > 0 && !confirm) {
                                this.$refs.repackConfirmDialog.openDialog();
                                return;
                            } else {
                                let repack_details = [];
                                this.selected_batches.forEach((b, i) => {
                                    let _temp = {};
                                    if (this.repack.is_nonconformance == "0") {
                                        _temp = {
                                            batch_id: b.batch_id,
                                            qty: this.repack_qty[this.pending_batches.map((p) => p.batch_id).indexOf(b.batch_id)],
                                        };
                                    } else {
                                        _temp = {
                                            qty: this.repack_qty[this.nonconformances.map((n) => n.nonconformance_id).indexOf(b.nonconformance_id)],
                                        };
                                    }
                                    repack_details.push(_temp);
                                });
                                this.repack.part_id = this.$route.params.id;
                                this.repack.repack_details = repack_details;
                            }
                        }
                        this.form_loader = true;
                        this.$store
                            .dispatch("fetchRepack", {
                                pk: "repack_id",
                                url: `repack`,
                                method: "post",
                                stateProperty: "repack",
                                body: this.repack,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.$router.push({ name: "repack" });
                                } else {
                                    this.form_loader = false;
                                }
                            });
                    }
                });
            }
        },
        getShippingUnitOptions() {
            this.$store.dispatch("fetchSetting", {
                url: "shipping_unit_options",
                method: "get",
                stateProperty: "shipping_unit_options",
                commit: true,
            });
        },
        getPending: _.debounce(
            function(type) {
                this.startLoader();
                this.table_loader = true;
                setTimeout(() => {
                    this.table_loader = false;
                }, 1500);
                this.getPartInfo(this.$route.params.id);
                if (type == "batches") {
                    this.$store
                        .dispatch("fetchRepack", {
                            url: "repack/pending_batches",
                            method: "get",
                            stateProperty: "pending_batches",
                            commit: true,
                            body: {
                                part_id: this.$route.params.id,
                            },
                        })
                        .then((data) => {
                            this.finishLoader();
                            this.repack_qty = Array((data.pending_batches || []).length).fill("");
                        });
                } else if (type == "nonconformances") {
                    this.$store
                        .dispatch("fetchNonconformance", {
                            url: "nonconformance",
                            method: "get",
                            stateProperty: "nonconformances",
                            commit: true,
                            body: {
                                part_id: this.$route.params.id,
                            },
                        })
                        .then((data) => {
                            this.finishLoader();
                            this.repack_qty = Array((data.nonconformances || []).length).fill("");
                        });
                }
            },
            1500,
            { maxWait: 1500, leading: true, trailing: false }
        ),
        getPartInfo(part_id = null) {
            if (part_id) {
                this.$store
                    .dispatch("fetchRepack", {
                        url: "parts/" + part_id,
                        method: "get",
                    })
                    .then((data) => {
                        if (data && data.parts && data.parts.repack_shipping_unit_id) {
                            this.repack.shipping_unit_id = data.parts.repack_shipping_unit_id;
                        } else {
                            this.repack.shipping_unit_id = "";
                        }
                    });
            } else {
                this.repack.shipping_unit_id = "";
            }
        },
    },
};
</script>
